// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3e4x3","title":"Header_title__kPwPj","side":"Header_side__Vhuka"};